import React from "react"
import { useState, useCallback, useContext } from "react"
import DodoneContext from 'app/dodones/Context'
import SpinnableButton from 'app/components/buttons/Spinnable'

export default ({ text = "Start" }) => {
  const { startDodone, updateDodone } = useContext(DodoneContext)
  const [isConfirmed, setIsConfimed] = useState(false)

  const onStart = useCallback(() => {
    if(!isConfirmed) {
      setIsConfimed(true)
      return
    }

    startDodone();
  })

  return <div className="input-group">
           <SpinnableButton className="btn btn-primary btn-block" onClick={ onStart } isSpinning={ updateDodone.isPending }>
             {
               isConfirmed ? 'Start?' : text
             }
           </SpinnableButton>
         </div>
}
